const apiHostWPatient = process.env.PUBLIC_URL
export const apiHostNoPatient = apiHostWPatient.substring(0, apiHostWPatient.length - 8)

export const spaEndpointHost = process.env.REACT_APP_HOST;
export const apiHost = apiHostNoPatient;
export const getwayApi = apiHostNoPatient;
export const vraUX = process.env.REACT_UX;
export const instkey = 'InstrumentationKey=4f254ea7-2eec-4f68-b038-744c9f7c9e5c';
export const captchaUrl = 'https://captcha-dev.azurewebsites.net';

// export const apiHost = 'https://app-vra-test.azurewebsites.net';
// export const getwayApi = 'https://app-vra-test.azurewebsites.net';